// extracted by mini-css-extract-plugin
export default {"container":"Switch_container__y0oSz","label":"Switch_label__04++O","labelDarkMode":"Switch_labelDarkMode__N3Lqn","labelMobile":"Switch_labelMobile__T-TGH"};